import { Modal } from 'antd';
import styles from '../style.module.scss';

const APPLY_INSTRUCTIONS =
  "Per candidarsi inviare il proprio CV completo di autorizzazione al trattamento dei dati personali, inserendo nell'oggetto il titolo del presente annuncio a";

/**
 * Modal with vacancy details and apply instructions.
 */
export function VacancyDetailModal({ vacancy, visible, onClose }) {
  if (!vacancy) return null;

  const hasApplyEmail = Boolean(vacancy.applyEmail?.trim());

  console.log('[VacancyDetailModal.js::15]:vacancy.hide_brand', vacancy);
  return (
    <Modal
      title={vacancy.title}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width='80%'
      className={styles.vacancyModalDialog}
      destroyOnClose
    >
      <div className={styles.modalBody}>
        <p>
          <strong>Outlet village: </strong>
          {vacancy.outletVillage}
        </p>
        {!vacancy.hide_brand && (
          <p>
            <strong>Insegna: </strong>
            {vacancy.insegna}
          </p>
        )}

        <p>
          <strong>Annuncio valido sino al: </strong>
          {vacancy.validUntil}
        </p>
        <p>{vacancy.title}</p>
        <p className={styles.modalDescription}>{vacancy.description}</p>
        <p className={styles.modalDescription}>
          {APPLY_INSTRUCTIONS}
          {hasApplyEmail ? (
            <>
              {' '}
              <a href={`mailto:${vacancy.applyEmail}`}>
                <strong>{vacancy.applyEmail}</strong>
              </a>
            </>
          ) : (
            ' (contatto non disponibile).'
          )}
        </p>
      </div>
    </Modal>
  );
}
